import { ofType } from 'redux-observable';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import {
  fetchFiles,
  fetchFilesSuccess,
  fetchFilesFailure,
  uploadFiles,
  uploadFilesSuccess,
  uploadFilesFailure,
  deleteFile,
  deleteFileSuccess,
  deleteFileFailure,
} from '../slices/fileSlice';

// 你可以用 .env 設：REACT_APP_UPLOAD_URL=https://minion2.heyadigi.cloud/api/upload_file/
const UPLOAD_URL =
  process.env.REACT_APP_UPLOAD_URL ||
  process.env.NEXT_PUBLIC_UPLOAD_URL ||
  'https://minion2.heyadigi.cloud/api/upload_file/';

// delete api
const DELETE_URL =
  process.env.REACT_APP_DELETE_URL ||
  process.env.NEXT_PUBLIC_DELETE_URL ||
  'https://minion2.heyadigi.cloud/api/delete_file/';


export const fetchFilesEpic = (action$) =>
  action$.pipe(
    ofType(fetchFiles.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_files/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
        responseType: 'json',
      }).pipe(
        map((res) => fetchFilesSuccess({ data: res.response?.data ?? [] })),
        catchError((err) =>
          of(
            fetchFilesFailure({
              msg: err?.response?.msg || err?.message || '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

// ✅ 上傳用 fetch（避免 rxjs/ajax 會自動帶 X-Requested-With 造成 CORS preflight 擋掉 → 你會只看到 "ajax error"）
export const uploadFilesEpic = (action$) =>
  action$.pipe(
    ofType(uploadFiles.type),
    mergeMap((action) =>
      from(
        (async () => {
          const { team_token, account_token, files } = action.payload || {};

          const fd = new FormData();
          fd.append('team_token', team_token || '');
          fd.append('account_token', account_token || '');
          (files || []).forEach((f) => fd.append('file', f));

          let res;
          try {
            res = await fetch(UPLOAD_URL, {
              method: 'POST',
              body: fd,
              // 跨網域 token 驗證，不靠 cookie
              credentials: 'omit',
            });
          } catch (e) {
            // fetch 網路層錯誤（CORS / DNS / 連不上）會直接 throw
            throw new Error(e?.message || 'Failed to fetch');
          }

          let json = null;
          try {
            json = await res.json();
          } catch (e) {}

          if (!res.ok) {
            const msg = json?.msg || json?.message || `上傳失敗（${res.status}）`;
            throw new Error(msg);
          }

          if (json && (json.status === 'ERROR' || json.status === 'FAIL')) {
            throw new Error(json.msg || '上傳失敗');
          }

          return uploadFilesSuccess({ data: json?.data ?? json });
        })()
      ).pipe(
        catchError((err) =>
          of(
            uploadFilesFailure({
              msg: err?.message || '網路或伺服器錯誤',
              raw: null,
            })
          )
        )
      )
    )
  );


// ✅ 刪除檔案用 fetch（同 upload：避免 rxjs/ajax 的 X-Requested-With 造成 CORS 問題）
export const deleteFileEpic = (action$) =>
  action$.pipe(
    ofType(deleteFile.type),
    mergeMap((action) =>
      from(
        (async () => {
          const { team_token, account_token, file_token } = action.payload || {};

          let res;
          try {
            res = await fetch(DELETE_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ team_token, account_token, file_token }),
              credentials: 'omit',
            });
          } catch (e) {
            throw new Error(e?.message || 'Failed to fetch');
          }

          let json = null;
          try {
            json = await res.json();
          } catch (e) {}

          if (!res.ok) {
            const msg = json?.msg || json?.message || `刪除失敗（${res.status}）`;
            throw new Error(msg);
          }

          if (json && (json.status === 'ERROR' || json.status === 'FAIL')) {
            throw new Error(json.msg || '刪除失敗');
          }

          return deleteFileSuccess({ data: json?.data ?? json });
        })()
      ).pipe(
        catchError((err) =>
          of(
            deleteFileFailure({
              msg: err?.message || '網路或伺服器錯誤',
              raw: null,
            })
          )
        )
      )
    )
  );

